import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { MAutocomplete } from 'common';

const InventoryOwnerAutoComplete = props => {
  const {
    autoClear,
    currentAffiliate,
    fetchInventoryOwners,
    inventoryOwners,
    onChange,
    selected,
    title,
    without,
  } = props;
  const theme = useTheme();
  const { dataCompanyId, customerIdName } = currentAffiliate;

  const [key, setKey] = useState();

  const options = R.o(
    R.map(({ companyCustomerIdName, nameShort }) => ({
      label: `${companyCustomerIdName} ${nameShort}`,
      value: companyCustomerIdName,
    })),
    R.without(without)
  )(inventoryOwners);

  const handleChange = R.compose(
    R.when(R.always(autoClear), setKey), // work-around to clear autocomplete
    R.prop('value'),
    R.tap(inventoryOwner =>
      onChange(R.find(R.propEq('companyCustomerIdName', inventoryOwner?.value), inventoryOwners))
    )
  );

  useEffect(() => {
    fetchInventoryOwners({ companyCustomerIdName: customerIdName, dataCompanyId });
  }, [dataCompanyId, fetchInventoryOwners, customerIdName]);

  return (
    <Box p={theme.spacing(3, 3, 2)}>
      <Typography sx={{ color: 'text.primary', pb: 2 }} variant="body1">
        {title}
      </Typography>
      <MAutocomplete
        blurOnSelect
        id="inventoryOwners"
        key={key}
        label="Inventory Owner"
        loading={false}
        name="inventoryOwner"
        onChange={R.flip(handleChange)}
        openOnFocus
        options={options}
        value={selected}
      />
    </Box>
  );
};

InventoryOwnerAutoComplete.propTypes = {
  autoClear: PropTypes.bool,
  currentAffiliate: PropTypes.shape({
    customerIdName: PropTypes.string.isRequired,
    dataCompanyId: PropTypes.number.isRequired,
  }).isRequired,
  fetchInventoryOwners: PropTypes.func.isRequired,
  inventoryOwners: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.string,
  title: PropTypes.string.isRequired,
  // list of already selected inventory owners to be filtered out
  without: PropTypes.arrayOf(PropTypes.shape({})),
};

InventoryOwnerAutoComplete.defaultProps = {
  autoClear: false,
  selected: '',
  without: [],
};

export default InventoryOwnerAutoComplete;
